export default __webpack_public_path__ + "static/05-cb788ed324ebf18027bd12f5341eb132.jpg";